import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { upperDarbyConfig } from "./data";

export default function UpperDarbyPage() {
  return <CityPageTemplate config={upperDarbyConfig} />;
}